export default __webpack_public_path__ + "static/media/leg-right-front.696477c7.png";